import './App.css';
import React, { useState } from 'react'
import { VideoRoom } from './components/VideoRoom';



function App() {
  const [joined ,setJoined] = useState(false);

  return (
    <div className="App">
     <h1 className='  mt-16 text-3xl font-bold  text-gray-950 text-center'>Want To Talk To Your Doctor</h1>

    {!joined && (
    <button onClick = { () => setJoined(true)} className=' h-18 w-28  rounded-md mt-96  font-semibold text-white bg-slate-800 size-14'> Join Room</button>

)}

   
   {joined &&(
    
    <VideoRoom></VideoRoom>

   )}



  </div>
  );
}

export default App;
